import { render, staticRenderFns } from "./RequisicaoAtualizar.vue?vue&type=template&id=45e41e78&"
import script from "./RequisicaoAtualizar.vue?vue&type=script&lang=js&"
export * from "./RequisicaoAtualizar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports